/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Outcomeformsubmitting2Inputs */

const en_outcomeformsubmitting2 = /** @type {(inputs: Outcomeformsubmitting2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saving…`)
};

const pt_outcomeformsubmitting2 = /** @type {(inputs: Outcomeformsubmitting2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A guardar…`)
};

/**
* | output |
* | --- |
* | "Saving…" |
*
* @param {Outcomeformsubmitting2Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const outcomeformsubmitting2 = /** @type {((inputs?: Outcomeformsubmitting2Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Outcomeformsubmitting2Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_outcomeformsubmitting2(inputs)
	return pt_outcomeformsubmitting2(inputs)
});
export { outcomeformsubmitting2 as "outcomeFormSubmitting" }